import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { request } from 'apis/core';
import { ApiResponse } from 'shared/types';

import {
  EmailCertificationRequest,
  PutUserInfoRequest,
  RequestAdminLoginType,
  RequestLoginType,
  RequestSignUpType,
  ResponseAdminLoginType,
  ResponseLoginType,
  verifyRequestCodeRequest,
} from '../model/dto';
import { requestEmailCertification, verifyRequestCode } from './service';

export const useEmailCertificationMutation = (
  options?: UseMutationOptions<ApiResponse, unknown, EmailCertificationRequest>,
) => {
  return useMutation<ApiResponse, unknown, EmailCertificationRequest>({
    mutationFn: requestEmailCertification,
    ...options,
  });
};

export const useVerifyRequestCodeMutation = (
  options?: UseMutationOptions<ApiResponse<string>, unknown, verifyRequestCodeRequest>,
) => {
  return useMutation<ApiResponse<string>, unknown, verifyRequestCodeRequest>({
    mutationFn: verifyRequestCode,
    ...options,
  });
};

// TODO: 컨벤션에 따라 수정 필요
export const auth = {
  socialSignUp: (data: RequestSignUpType) => {
    request.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${data.accessToken}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    return request.post<string>('/auth/admin/sign-up/social', data);
  },

  emailSignUp: (data: RequestSignUpType & { password: string }) => {
    request.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${data.accessToken}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    // 승인 대기 방식으로 변경: 토큰 없이 안내 문자열만 반환된다.
    return request.post<string>('/auth/admin/sign-up/form', data);
  },

  login: (data: RequestLoginType) => {
    return request.get<ResponseLoginType>(`/auth/admin/login/kakao?code=${data.code}&redirectUri=${data.redirectUri}`);
  },

  adminLogin: (data: RequestAdminLoginType) =>
    request.post<ResponseAdminLoginType>('/auth/admin/checkmate-admin/login', data),

  putUserInfo: ({ id, ...data }: PutUserInfoRequest) => request.put(`/admin/${id}`, data),

  logout: () => request.post('/auth/logout'),
};
